import { useMutation } from '@tanstack/react-query';
import { createOneOffPayment } from '@/api/query/payment';
import { getUserTokens } from '@/api/query/customer';
import { normalizePlanName } from '@/common/constants/planNames';
import storageManager from '@/api/storageManager';
import {
	getMailLinkKey,
	getPaymentBrowsingPersonId,
	getPaymentUtms,
	isQuizPaymentContext,
} from '@/common/functions/getUtms';
import { buildHostedCheckoutUrls } from '../utils/buildHostedCheckoutUrls';

export const useBuyTokensPayment = ({
	returnPath,
	userId,
	userEmail,
	selectedKey,
	termsAccepted,
}) => {
	const paymentMutation = useMutation({
		mutationFn: async (payload) => {
			const { data: currentTokens } = await getUserTokens();
			storageManager.payment.setTokenBaseline(Number(currentTokens) || 0);

			return createOneOffPayment(payload);
		},
		onSuccess: ({ data }) => {
			if (!data?.link) {
				return;
			}

			window.location.href = data.link;
		},
	});

	const canPurchase =
		selectedKey && termsAccepted && !paymentMutation.isPending;

	const handlePayment = () => {
		if (!canPurchase || !selectedKey) {
			return;
		}

		const { successUrl, cancelUrl } = buildHostedCheckoutUrls(
			returnPath,
			userEmail,
		);
		const mailLinkKey = getMailLinkKey();
		const browsingPerson = getPaymentBrowsingPersonId();
		const payload = {
			plan: normalizePlanName(selectedKey),
			type: 'STRIPE',
			paymentFor: 'TOKENS',
			paymentUtms: getPaymentUtms(),
			customerId: userId,
			customerEmail: userEmail,
			fromQuiz: isQuizPaymentContext(),
			successUrl,
			cancelUrl,
		};

		if (browsingPerson) {
			payload.browsingPerson = browsingPerson;
		}

		if (mailLinkKey) {
			payload.mailLinkKey = mailLinkKey;
		}

		paymentMutation.mutate(payload);
	};

	return {
		canPurchase,
		handlePayment,
		isPending: paymentMutation.isPending,
	};
};
